import {Adds} from '~env/Env';

export const adds: Adds = {
  defaultLanguage: 'pt-BR',
};
